/**
 * This file will contain utility functions related to Handsontable instance data manipulation.
 */
import Handsontable from 'handsontable/base';

// Types
import { CellData } from '../../../../../../common/table/TableTypes';
import { CellProperties } from 'handsontable/settings';
import { set } from 'lodash';

const getTableCellData = (cellMetas: CellProperties[], toRow: number, toCol: number): CellData[][] => {
    const data: CellData[][] = [];

    cellMetas.forEach((cellMeta) => {
        const { row, col, cellData } = cellMeta || {};
        if (cellData && row < toRow && col < toCol) set(data, [row, col], cellData);
    });

    return data;
};

/**
 * Returns all the cell data via the HoT instance.
 */
export const getHotTableData = (hotInstance: Handsontable | null | undefined): CellData[][] | undefined => {
    if (!hotInstance) return;

    const cellMetas = hotInstance.getCellsMeta();
    const rowCount = hotInstance.countRows();
    const colCount = hotInstance.countCols();

    return getTableCellData(cellMetas, rowCount, colCount);
};
